<div class="flex flex-row items-center gap-2">
    <span class="grow"> {{ label | translate }} </span>

    <app-table-order-button
        [orderBy]="tableController.filter.orderBy[orderByColumnName]"
        (orderByChange)="onChange($event)"
    ></app-table-order-button>
</div>
